import { useEffect, useState } from 'react';
import axios from 'axios';

export function useAPIService(API_URL, params) {
    const [result, setResult] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios
            .post(API_URL, params)
            .then((res) => {
                if (Array.isArray(res.data.result)) {
                    setResult(res.data.result);
                } else {
                    setError("Unexpected FAQ data format from API");
                }
            })
            .catch(() => {
                setError("Failed to load FAQs. Please try again later.");
            })
            .finally(() => {
                setLoading(false);
            });
    }, [API_URL, params]);

    return { result, loading, error };
}